/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { L as Loader, d as defineCustomElement$1 } from './loader.js';

const CalciteLoader = Loader;
const defineCustomElement = defineCustomElement$1;

export { CalciteLoader, defineCustomElement };

//# sourceMappingURL=calcite-loader.js.map